<template>
  <div class="flex flex-col justify-center">
    <div class="mx-4 ">
      <h1 class="text-white text-center text-lg font-bold p-4">
        انتخاب عکس بنر
      </h1>
      <h6
        class="text-gray-100 rounded-xl py-1 mt-2 text-xs text-center bg-red-500"
      >
        عرض و ارتفاع عکس انتخابی باید 338 * 600 باشد
      </h6>
      <div class="rounded-xl p-4 bg-gray-900 mt-6">
        <input
          type="file"
          @change="onFileChange(1)"
          class="text-white mt-6 mr-6"
        />
        <div id="preview" class="rounded-xl p-4 bg-gray-900">
          <img v-if="urlBanner" :src="urlBanner" />
        </div>
        <h6
          class="text-white rounded-xl py-2 mt-2 text-xs text-center bg-red-500"
          v-if="sizeError.baner"
        >
          عرض و ارتفاع عکس انتخابی باید 338 * 600 باشد
        </h6>
      </div>
      <Button class="mt-4" type="button" @click="submitFile(1)">آپلود</Button>
    </div>
    <hr class="border-yellow-400 mx-4 my-6" />
    <div class="mx-4">
      <h1 class="text-white text-center text-lg font-bold p-4">
        انتخاب عکس منو
      </h1>
      <h6
        class="text-gray-100 rounded-xl py-1 mt-2 text-xs text-center bg-red-500"
      >
        عرض و ارتفاع عکس انتخابی باید 480 * 720 باشد
      </h6>
      <div class="rounded-xl p-4 bg-gray-900 mt-6">
        <input
          type="file"
          @change="onFileChange(2)"
          class="text-white mt-6 mr-6"
        />
        <div id="preview" class="rounded-xl p-4 bg-gray-900">
          <img v-if="urlMenu" :src="urlMenu" />
        </div>
        <Input
          type="number"
          class="mt-1 text-center"
          placeholder="کد منو"
          v-model="menuCodeHeader"
          required
        />
        <h6
          class="text-white rounded-xl py-2 mt-2 text-xs text-center bg-red-500"
          v-if="sizeError.menu"
        >
          عرض و ارتفاع عکس انتخابی باید 480 * 720 باشد
        </h6>
        <h6
          class="text-white rounded-xl py-2 mt-2 text-xs text-center bg-red-500"
          v-if="menuCodeError"
        >
          کد منو الزامی است
        </h6>
      </div>
      <Button class="mt-4" type="button" @click="submitFile(2)">آپلود</Button>
    </div>
    <hr class="border-yellow-400 mx-4 my-6" />
    <div class="mx-4 mb-10">
      <h1 class="text-white text-center text-lg font-bold p-4">
        انتخاب عکس غذا
      </h1>
      <h6
        class="text-gray-100 rounded-xl py-1 mt-2 text-xs text-center bg-red-500"
      >
        عرض و ارتفاع عکس انتخابی باید 480 * 720 باشد
      </h6>
      <div class="rounded-xl p-4 bg-gray-900 mt-6">
        <input
          type="file"
          @change="onFileChange(3)"
          class="text-white mt-6 mr-6"
        />
        <div id="preview" class="rounded-xl p-4 bg-gray-900">
          <img v-if="urlProduct" :src="urlProduct" />
        </div>
        <Input
          type="number"
          class="mt-1 text-center"
          placeholder="کد غذا"
          v-model="productCodeHeader"
          required
        />
        <h6
          class="text-white rounded-xl py-2 mt-2 text-xs text-center bg-red-500"
          v-if="sizeError.product"
        >
          عرض و ارتفاع عکس انتخابی باید 480 * 720 باشد
        </h6>
        <h6
          class="text-white rounded-xl py-2 mt-2 text-xs text-center bg-red-500"
          v-if="productCodeError"
        >
          کد غذا الزامی است
        </h6>
      </div>
      <Button class="mt-4" type="button" @click="submitFile(3)">آپلود</Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/General/Button";
import Input from "@/components/Input";
import { UploadImage } from "@/API/API";

export default {
  name: "UploadBanner",
  components: { Button, Input },
  data() {
    return {
      file: null,
      urlBanner: null,
      urlMenu: null,
      urlProduct: null,
      sizeError: {
        baner: false,
        menu: false,
        product: false,
      },
      menuCodeHeader: null, // کد منو
      productCodeHeader: null, // کد محصول
      menuCodeError: false, // خطای الزامی بودن کد منو
      productCodeError: false, // خطای الزامی بودن کد محصول
      bannertopapp: null,
      bannertopError: false,
    };
  },
  methods: {
    onFileChange(typeHeader) {
      const inputElement = event.target;
      this.file = inputElement.files[0];
      this.menuCodeError = false; // ریست خطای کد منو
      this.productCodeError = false; // ریست خطای کد محصول
      if (this.file) {
        console.log("Selected file:", this.file);
        const url = URL.createObjectURL(this.file); // ایجاد URL
        // به‌روزرسانی urlBanner، urlMenu، یا urlProduct
        if (typeHeader === 1) {
          this.urlBanner = url;
        } else if (typeHeader === 2) {
          this.urlMenu = url;
        } else if (typeHeader === 3) {
          this.urlProduct = url;
        }

        const img = new Image();
        img.src = url; // بارگذاری تصویر
        img.onload = () => {
          // Check dimensions based on typeHeader
          if (typeHeader === 1) {
            this.sizeError.baner = img.width !== 600 || img.height !== 338;
          } else if (typeHeader === 2) {
            this.sizeError.menu = img.width !== 720 || img.height !== 480;
          } else if (typeHeader === 3) {
            this.sizeError.product = img.width !== 720 || img.height !== 480;
          }
        };
      } else {
        console.log("No file selected");
      }
    },
    submitFile(typeHeader) {
      const params = new FormData();
      params.append("Logo", this.file);

      if (
        !this.file ||
        (typeHeader === 1 && this.sizeError.baner) ||
        (typeHeader === 2 && (this.sizeError.menu || !this.menuCodeHeader)) ||
        (typeHeader === 3 &&
          (this.sizeError.product || !this.productCodeHeader))
      ) {
        console.log("No file selected or size error exists.");
        if (typeHeader === 2 && !this.menuCodeHeader) {
          this.menuCodeError = true;
        }
        if (typeHeader === 3 && !this.productCodeHeader) {
          this.productCodeError = true;
        }
        return;
      }
      UploadImage(
        params,
        typeHeader,
        this.menuCodeHeader,
        this.productCodeHeader
      )
        .then((resp) => {
          console.log(resp);
          this.$swal({
            icon: "success",
            title: "موفق",
            text: "آپلودعکس با موفقیت انجام شد",
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          }).then(() => {
           
          });
        })
        .catch((e) => {
          console.log(
            "Error uploading file:",
            e.response ? e.response.data : e.message
          );
        });
    },
  },
};
</script>
